export default __webpack_public_path__ + "static/media/HelpIcon.46c2e5b8.svg";